import { render, staticRenderFns } from "./curveRecommend.vue?vue&type=template&id=1e26459b"
import script from "./curveRecommend.vue?vue&type=script&lang=js"
export * from "./curveRecommend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports